import { Button, Card, Flex, Modal, Typography } from "antd";
import CustomIcon from "../../layouts/CustomIcon";
import { useAuthContext } from "../../user/AuthProvider";
import { normalizeCreditsValue, roundCredits } from "../../../utills/common";
import { PRODUCTS, TEST_TYPE_TASK } from "../../../actions/constants";
import SimpleBar from "simplebar-react";

const { Text, Title } = Typography;

export default function CreditsHelpModal({ open = false, setOpen = () => {} }) {
  const { products, user, subscription, planInfo } = useAuthContext();
  const { credits } = user || {};
  const { isCustomPlan, isTrialPlan } = planInfo || {};
  const { plan_comparison, own_users } = subscription?.plan || {};

  return (
    <Modal
      width={650}
      destroyOnHidden={true}
      open={open}
      centered
      closable={false}
      footer={null}
      onCancel={() => setOpen(false)}
      mask={{ closable: false }}
    >
      <Flex vertical gap={16}>
        <Flex align='center' justify='space-between'>
          <Title level={5} className='m-0 font-size-18px'>
            How pooled credits work on UXArmy
          </Title>
          <Button type='text' size='small' onClick={() => setOpen(false)}>
            <CustomIcon name='close' />
          </Button>
        </Flex>

        <SimpleBar className='st-8px pr-2' style={{ height: 600 }}>
          <Flex vertical gap={16}>
            <Flex align='flex-start' gap={10}>
              <CustomIcon name='bar_chart_square_01' width={36} height={36} />
              <Flex vertical gap={5}>
                <Text className='font-size-16px fw-600'>Flexibility in usage</Text>
                <Text>
                  Pooled credits are allocated in every subscription Plan. You can use them across all research methods on UXArmy
                  platform.
                </Text>
              </Flex>
            </Flex>

            <Text className='color-3F3F50'>Each research method uses credits differently:</Text>

            <Flex vertical gap={5}>
              {products?.map(({ key, name, type, isNoRecording }) => {
                const productType = type === TEST_TYPE_TASK && isNoRecording ? PRODUCTS.NORECORDING : type;
                const credit = credits?.[productType]?.random;
                return (
                  <Card className='bg-F5F6F9' styles={{ body: { padding: "10px" } }} key={key}>
                    <Flex align='center' justify='space-between'>
                      <Text className='color-3F3F50'>{name}</Text>
                      <Text className='color-3F3F50 fw-500'>{roundCredits(credit)} credits/response</Text>
                    </Flex>
                  </Card>
                );
              })}
            </Flex>

            {!isCustomPlan && !isTrialPlan && (
              <Card className='bg-EAEFFD border-CDD9FA' styles={{ body: { padding: "10px" } }}>
                <Flex vertical gap={15}>
                  <Flex vertical gap={3}>
                    <Text className='fw-600'>Example</Text>
                    <Text>With a {own_users} pooled credit allocation, you can run:</Text>
                  </Flex>

                  <Flex vertical gap={3}>
                    <Text>{normalizeCreditsValue(plan_comparison?.task)} recorded usability tests</Text>
                    <Text>or {normalizeCreditsValue(plan_comparison?.moderated)} user interviews</Text>
                    <Text>or a {normalizeCreditsValue(plan_comparison?.survey)} response survey</Text>
                    <Text>or any combination within the credit limit</Text>
                  </Flex>
                </Flex>
              </Card>
            )}

            <Flex align='flex-start' gap={10} className='mt-1 mb-1'>
              <CustomIcon name='lightning_01_h' width={36} height={36} />
              <Flex vertical gap={5}>
                <Text className='font-size-16px fw-600'>Overages</Text>
                <Text>
                  If you exceed your allocated pooled credits, the cost of extra credits will appear at test launch. If you proceed
                  with the launch, these additional charges will be added to your next invoice.
                </Text>
                <Text>Enterprise plans will see a prompt to contact UXArmy when credits are running low.</Text>
              </Flex>
            </Flex>
          </Flex>
        </SimpleBar>
      </Flex>
    </Modal>
  );
}
